package com.essntl.features.task.ui.addedittask.components

import androidx.compose.runtime.Composable
import androidx.compose.ui.platform.LocalUriHandler
import com.essntl.features.itinerary.domain.model.shareLink
import com.essntl.features.task.domain.model.TaskModel
import com.essntl.features.task.ui.addedittask.AddEditTaskNavigation
import com.essntl.features.task.ui.addedittask.AddEditTaskState
import com.essntl.uikit.components.card.EsExpandableCardsSection
import com.essntl.uikit.components.iconbutton.outline.EsSmallOutlineIconButton
import com.essntl.uikit.components.iconbutton.primary.EsSmallPrimaryIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.rememberNumberOfDaysPrettyString
import core.dateformat.ui.formatDate

@Composable
fun TaskItinerarySection(
    state: AddEditTaskState,
    task: TaskModel?,
    onNavigation: ((AddEditTaskNavigation) -> Unit)?,
) {
    val uriHandler = LocalUriHandler.current

    state.sharedTaskState.getAllItineraries.data
        ?.filter {
            it.id == task?.itinerary?.id ||
                it.id == task?.itineraryService?.itineraryId
        }
        ?.let { itineraries ->
            if (itineraries.isNotEmpty()) {
                EsExpandableCardsSection(
                    items = itineraries,
                    title = "Itineraries",
                    cardTitle = { it.proposal?.title ?: "" },
                    cardSubtitle = {
                        val dateDiff =
                            rememberNumberOfDaysPrettyString(
                                it.proposal?.fromDate,
                                it.proposal?.toDate,
                            )

                        it.proposal?.fromDate?.formatDate(
                            ".",
                            excludeYear = true,
                        ) +
                            " - " +
                            it.proposal?.toDate?.formatDate(
                                ".",
                                excludeYear = true,
                            ) + '\n' + dateDiff
                    },
                    cardActionButtons = {
                        EsSmallOutlineIconButton(
                            onClick = {
                                it.shareLink?.let { link ->
                                    uriHandler.openUri(
                                        uri = link,
                                    )
                                }
                            },
                            iconRes = EsIcons.Browse,
                        )

                        if (onNavigation != null) {
                            EsSmallPrimaryIconButton(
                                onClick = {
                                    onNavigation(AddEditTaskNavigation.EditItinerary(it.id))
                                },
                                iconRes = EsIcons.Edit,
                            )
                        }
                    },
                )
            }
        }
}